module.exports = __webpack_public_path__ + "img/cash.07660112.svg";